import Component from 'components/pages/Faq/Faq.qmee';
import { buildPage, buildStaticProps } from 'utils/pageHelper';

export const getServerSideProps = buildStaticProps('faq', {
  withoutHeaderOnMobile: true,
  withoutFooterOnMobile: true,
});
export default buildPage(Component, {
  requiresAuthentication: false,
  metaData: {
    title: 'How It Works',
    description: 'How It Works Page',
  },
});
